// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconCart(Props) {
  var sizeOpt = Props.size;
  var className = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : 24;
  var tmp = {
    height: size.toString(),
    width: size.toString(),
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.8",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z"
  }), React.createElement("path", {
    d: "M9 11v-5a3 3 0 0 1 6 0v5"
  }));
}
IconCart.displayName = "IconCart";
var make = IconCart;
export { make };
/* react Not a pure module */